/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateFolderInput = {
    clientMutationId?: string | null;
    slug: string;
    name: string;
};
export type FolderMutationVariables = {
    input: infoUpdateFolderInput;
};
export type FolderMutationResponse = {
    readonly infoUpdateFolder: {
        readonly clientMutationId: string | null;
    } | null;
};
export type FolderMutation = {
    readonly response: FolderMutationResponse;
    readonly variables: FolderMutationVariables;
};



/*
mutation FolderMutation(
  $input: infoUpdateFolderInput!
) {
  infoUpdateFolder(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdateFolderPayload",
    "kind": "LinkedField",
    "name": "infoUpdateFolder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FolderMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FolderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b3feff5415fe16a13f37615e1dcc857b",
    "id": null,
    "metadata": {},
    "name": "FolderMutation",
    "operationKind": "mutation",
    "text": "mutation FolderMutation(\n  $input: infoUpdateFolderInput!\n) {\n  infoUpdateFolder(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '41373cd765baab9878883c2c19976f5c';
export default node;
